import React, {useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {ResendLoginOtp, VerifyMailService} from "../services/auth";
import {admin_role_id, contractor_role_id, super_admin_role_id} from "../constant";
import {sweetAlerts} from "../utils/sweet-alerts";

const EmailVerifiedPage = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [loader, setLoader] = useState(false);
	const [status, setStatus] = useState(false);

	const [otp, setOtp] = useState(null);
	const [otpResendLoader, setOtpResendLoader] = useState(false);

	const verification = async (query) => {
		const queryParams = new URLSearchParams(location.search);
		const userUuid = queryParams.get("uuid");

		setStatus(false);
		setLoader(true);
		await VerifyMailService({uuid: userUuid, otp})
			.then((response) => {
				setLoader(false);
				if (response?.status) {
					setStatus(true);

					const message = "Your email is verity successfully!";
					sweetAlerts("success", message);

					const RoleString = response.data.role === "super-admin" ? super_admin_role_id : response.data.role === "admin" ? admin_role_id : contractor_role_id;
					localStorage.setItem("auth_token", response.data.token);
					localStorage.setItem("is_login", true);
					localStorage.setItem("first_name", response.data.first_name);
					localStorage.setItem("last_name", response.data.last_name);
					localStorage.setItem("role", RoleString);
					localStorage.setItem("verified", response.data.verified);
					localStorage.setItem("trusted", response.data.trusted);

					if (response.data.role === "contractor") {
						// window.location.href = HOME_URL + "/contractor-dashboard";
						window.location.href = "/contractor-dashboard";
					}
					if (response.data.role === "super-admin") {
						// window.location.href = HOME_URL + "/admin-dashboard";
						window.location.href = "/admin-dashboard";
					}
					if (response.data.role === "admin") {
						// window.location.href = HOME_URL + "/admin-dashboard";
						window.location.href = "/admin-dashboard";
					}
				} else {
					sweetAlerts("error", response.message);
				}
			})
			.catch((error) => {
				console.log(error, "error");

				sweetAlerts("error", error.message);
			});
	};

	const ResendOtp = async () => {
		const queryParams = new URLSearchParams(location.search);
		const userUuid = queryParams.get("uuid");

		// setLoader(true);
		setOtpResendLoader(true);
		await ResendLoginOtp({uuid: userUuid})
			.then((response) => {
				setOtpResendLoader(false);
				if (response?.status) {
					const message = "We've sent an Code to your email successfully!";
					sweetAlerts("success", message);
				} else {
				}
			})
			.catch(() => {});
	};

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const userUuid = queryParams.get("uuid");

		// verification(userUuid);

		document.body.style.overflow = "hidden";

		return () => {
			document.body.style.overflow = "auto";
		};
	}, [location.search]);

	return (
		<div className="modern-login-container">
			<div className="row g-0 h-100">
				{/* Left Side - Logo and Form */}
				<div className="col-lg-6 login-form-section">
					<div className="login-content">
						{/* Header with Logo and Back Link */}
						<div className="login-header">
							<div className="login-logo-container">
								<Link to="/" style={{textDecoration: "none"}}>
									<img src={`${process.env.PUBLIC_URL}/img/header-logo.png`} alt="JobSiteRating Logo" className="login-main-logo" />
								</Link>
							</div>
						</div>

						<div className="login-form-container">
							<div class="row h-100">
								{loader ? (
									<div className="dashboard-page">
										<div className="loading-container">
											<div className="spinner-large"></div>
											<h3>Verify Mail...</h3>
										</div>
									</div>
								) : (
									<>
										{/* {status ? (
											<div class="col-md-12 h-100">
												<div class="email-verification-banner verified">
													<div class="d-flex align-items-center justify-content-center">
														<div class="verification-icon me-3">
															<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
																	stroke="currentColor"
																	strokeWidth="2"
																	strokeLinecap="round"
																	strokeLinejoin="round"
																/>
															</svg>
														</div>
														<div class="verification-content">
															<h6 class="mb-1 verification-title">Email Verified</h6>
															<p class="mb-0 verification-message">Your account has been successfully verified. You now have full access to all platform features.</p>
														</div>
													</div>
												</div>
											</div>
										) : (
											<div class="col-md-12">
												<div class="email-verification-banner unverified">
													<div class="d-flex align-items-center justify-content-center">
														<div class="verification-icon me-3">
															<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
																	stroke="currentColor"
																	strokeWidth="2"
																	strokeLinecap="round"
																	strokeLinejoin="round"
																/>
															</svg>
														</div>
														<div class="verification-content">
															<h6 class="mb-1 verification-title">Email Not Verified</h6>
															<p class="mb-0 verification-message">Account verification failed. Please check your verification link or contact support for assistance.</p>
														</div>
													</div>
												</div>

												<button
													type="button"
													className="submit-btn mt-3"
													onClick={() => {
														navigate("/login");
													}}>
													Back Sign in
												</button>
											</div>
										)} */}

										<div className="otp-verification-section">
											<div className="otp-header">
												<div className="otp-icon">
													<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M22 2H2V22H22V2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
														<path d="M22 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
														<path d="M6 12H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
														<path d="M12 6V2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
														<path d="M12 22V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
													</svg>
												</div>
												<h3 className="otp-title">Email Verification</h3>
												<p className="otp-subtitle">We've sent a 6-digit code</p>
											</div>

											<form className="otp-form">
												<div className="form-group">
													<label htmlFor="otp" className="form-label">
														Verification Code
													</label>
													<input
														type="text"
														id="otp"
														className="form-input otp-input"
														placeholder="123456"
														maxLength="6"
														onChange={(e) => {
															const value = e.target.value.replace(/\D/g, "");
															setOtp(value);
														}}
														value={otp}
													/>
												</div>

												<button type="button" className="submit-btn" onClick={verification}>
													Verify Code
												</button>

												<div className="otp-actions">
													<button type="button" className={`w-100 ${otpResendLoader && "btn-close"} resend-btn`} onClick={ResendOtp} disabled={otpResendLoader}>
														Didn't receive code? Resend
													</button>
												</div>
											</form>
										</div>
									</>
								)}
							</div>
							{/* Tab Navigation */}
						</div>
					</div>
				</div>

				{/* Right Side - Image */}
				<div className="col-lg-6 login-image-section">
					<div className="image-container">
						<img src={`${process.env.PUBLIC_URL}/img/login2.png`} alt="Industrial Construction Site" className="login-background-image" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default EmailVerifiedPage;
